// extracted by mini-css-extract-plugin
export default {"reportView":"petitions-report_reportView__JmS2Z","pdfButton":"petitions-report_pdfButton__gUVIz"};